export const BASE_Z_INDEX = 1;

export const LAYOUT_MAX_WIDTH = 375;

export const MAX_Z_INDEX = 9999;

export const HEADER_Z_INDEX = 99;

export const BNB_Z_INDEX = 99;

export const GNB_Z_INDEX = 100;

export const APP_BAR_BOTTOM_Z_INDEX = BNB_Z_INDEX + 10;

export const HEADER_HEIGHT = 48;

export const BNB_HEIGHT = 55;

export const GNB_HEIGHT = 40;

export const APP_BAR_BOTTOM_HEIGHT = 71;

export const UNTACT_CONSULT_Z_INDEX = APP_BAR_BOTTOM_Z_INDEX;

export const SHOP_BOTTOM_SHEET_MIN_HEIGHT = 68;

export const FLOATING_BUTTON_Z_INDEX = BNB_Z_INDEX;

export const STICKY_Z_INDEX = BNB_Z_INDEX - 1;

export const TOAST_Z_INDEX = MAX_Z_INDEX;

export const BOTTOM_SHEET_BASE_Z_INDEX = 1100;

export const TOOLTIP_Z_INDEX = BNB_Z_INDEX - 1;
